// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"81":"c6750ed1","268":"f5849c91","349":"770be8ed","770":"bd703520","882":"f4c0ef4d","887":"d317b02e"}[chunkId] + ".chunk.js";
};